{% block sw_cms_block_acris_blog_title %}
    <div class="sw-cms-block-acris-blog-title">
        <slot name="column"></slot>
    </div>
{% endblock %}
